import { types } from "../types/types";

const initialState = {
  checking: true,
  uid: null,
  name: null,
  role: null,
  isSuperAdmin: 0,
  cityId: null,
  jugnoId: null,
};

export const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.authLogin:
      return {
        ...state,
        checking: false,
        ...action.payload,
      };
    case types.authCheckingFinish:
      return {
        ...state,
        checking: false,
      };
    case types.authLogout:
      return {
        checking: true,
      };

    default:
      return state;
  }
};
